import { createResource } from 'react-resource-router';

import { type ResourceDependencies } from '../../../common/types';
import { getOpsTeamsEndpoint } from '../../endpoints/ops-teams';

export const createOpsTeamsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'opsTeamsResource',
		getKey: () => 'opsTeamsResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getOpsTeamsEndpoint().then((response) => {
				return response.values;
			});
		},
		isBrowserOnly: true,
		depends,
	});
